module.exports = __webpack_public_path__ + "img/4.2e4b1e32.png";